import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from 'next/head';


const DesktopThemePark = dynamic(() => import('../../components/UAEPages/themeParks/DesktopThemePark'), {
    loading: () => <Loading />

});

const MobileThemePark = dynamic(() => import('../../components/UAEPages/themeParks/MobileThemePark'), {
    loading: () => <Loading />

});


const ThemeParks = ({ mobileView }) => {
  return (
    <div>
      <Head>
        <title>Theme Park POS UAE | VAT Billing, Ticketing & Inventory</title>
        <meta name="description" content="QueueBuster POS for UAE theme parks with ticketing, VAT billing, F&B, retail, stock control, CRM, and multi-outlet support. Manage operations faster and smarter."/>
        <link rel="canonical" href="https://queuebuster.co/ae-en/theme-parks" />
        <link rel="alternate" href="https://queuebuster.co/ae-en/theme-parks" hrefLang="en" />
        <meta property="og:title" content="QueueBuster Theme Park POS UAE – Ticketing, VAT Billing & F&B Management" />
        <meta property="og:description" content="QueueBuster POS is designed for UAE theme parks—manage ticketing, VAT billing, F&B counters, rides, retail, merch stores, CRM, and stock across all outlets. Enable fast operations, online bookings, and real-time analytics for a seamless guest experience."/>
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Image+Amusement+park.png" />
        <meta property="og:url" content="https://queuebuster.co/ae-en/theme-parks" />

      </Head>
        {mobileView ? <MobileThemePark /> : <DesktopThemePark />}
    </div>
  )
}


export default ThemeParks